var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebmaster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 820.611,
    height: 538.44,
    viewBox: "0 0 820.611 538.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24748a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24748a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7a90"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_517",
    "data-name": "Grupo 517",
    transform: "translate(7160 21734.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_561",
    "data-name": "Trazado 561",
    d: "M510.014,654.569l-10.6-4.464-7.273-53.146H395.292l-7.883,52.928-9.485,4.742a2.252,2.252,0,0,0,1.007,4.267H509.14a2.252,2.252,0,0,0,.874-4.328Z",
    transform: "translate(-7356.539 -21994.813)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_562",
    "data-name": "Trazado 562",
    d: "M614.47,577.89H138.728a9.425,9.425,0,0,1-9.4-9.425V501.379h494.55v67.086a9.425,9.425,0,0,1-9.4,9.425Z",
    transform: "translate(-7288.889 -21968.676)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_563",
    "data-name": "Trazado 563",
    d: "M624.208,432.688H128.726V145.643a11.375,11.375,0,0,1,11.363-11.363H612.846a11.375,11.375,0,0,1,11.363,11.362Z",
    transform: "translate(-7288.726 -21868.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_564",
    "data-name": "Trazado 564",
    d: "M602.457,419.7H166.163a8.769,8.769,0,0,1-8.76-8.759V171.716a8.77,8.77,0,0,1,8.76-8.76H602.457a8.77,8.77,0,0,1,8.76,8.76V410.937A8.769,8.769,0,0,1,602.457,419.7Z",
    transform: "translate(-7296.569 -21876.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_565",
    "data-name": "Trazado 565",
    d: "M545.423,682.14H300.263a1.138,1.138,0,0,1-1.118-.824,1.111,1.111,0,0,1,1.073-1.394H545.333a1.174,1.174,0,0,1,1.174.867,1.11,1.11,0,0,1-1.083,1.351Z",
    transform: "translate(-7335.323 -22017.512)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_251",
    "data-name": "Rect\\xE1ngulo 251",
    width: 105.341,
    height: 80.478,
    transform: "translate(-6804.11 -21674.492)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_252",
    "data-name": "Rect\\xE1ngulo 252",
    width: 94.872,
    height: 72.48,
    transform: "translate(-6798.877 -21670.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_566",
    "data-name": "Trazado 566",
    d: "M693.162,276.69h.037a25.295,25.295,0,0,0,.566-50.484.579.579,0,0,0-.623.569l-.553,49.332a.579.579,0,0,0,.573.584Z",
    transform: "translate(-7442.936 -21893.42)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_567",
    "data-name": "Trazado 567",
    d: "M663.472,237.433a.745.745,0,0,1,.523.223l16.983,17.368a.737.737,0,0,1,.211.527l-.265,23.606a.735.735,0,0,1-.24.537.745.745,0,0,1-.56.195,25.46,25.46,0,0,1-17.218-42.2.746.746,0,0,1,.538-.252Z",
    transform: "translate(-7433.083 -21896.494)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_568",
    "data-name": "Trazado 568",
    d: "M683.892,225.927a.747.747,0,0,1,.508.208.735.735,0,0,1,.228.543l-.239,21.3a.742.742,0,0,1-1.272.51L668.3,233.331a.743.743,0,0,1,.04-1.076,25.514,25.514,0,0,1,15.508-6.326Z",
    transform: "translate(-7436.234 -21893.35)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_569",
    "data-name": "Trazado 569",
    d: "M675.913,308.046a4.543,4.543,0,1,1-4.492-4.594A4.543,4.543,0,0,1,675.913,308.046Z",
    transform: "translate(-7435.89 -21914.547)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_570",
    "data-name": "Trazado 570",
    d: "M693.779,308.247a4.543,4.543,0,1,1-4.492-4.594A4.543,4.543,0,0,1,693.779,308.247Z",
    transform: "translate(-7440.776 -21914.604)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_571",
    "data-name": "Trazado 571",
    d: "M711.645,308.447a4.543,4.543,0,1,1-4.492-4.594A4.543,4.543,0,0,1,711.645,308.447Z",
    transform: "translate(-7445.662 -21914.656)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_253",
    "data-name": "Rect\\xE1ngulo 253",
    width: 105.341,
    height: 80.478,
    transform: "translate(-6805.218 -21581.354)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_254",
    "data-name": "Rect\\xE1ngulo 254",
    width: 94.872,
    height: 72.48,
    transform: "translate(-6799.986 -21577.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_37",
    "data-name": "Elipse 37",
    cx: 3.939,
    cy: 3.939,
    r: 3.939,
    transform: "translate(-6787.827 -21561.406)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_572",
    "data-name": "Trazado 572",
    d: "M716.691,372.8a2.672,2.672,0,1,1,0,5.343h-41.43a2.672,2.672,0,1,1,0-5.343h41.43m0-.654h-41.43a3.326,3.326,0,1,0,0,6.651h41.43a3.326,3.326,0,1,0,0-6.651Z",
    transform: "translate(-7437.287 -21933.338)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_573",
    "data-name": "Trazado 573",
    d: "M698.046,378.8H666.858a3.326,3.326,0,1,1,0-6.652h31.188a3.326,3.326,0,1,1,0,6.651Z",
    transform: "translate(-7434.988 -21933.338)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_38",
    "data-name": "Elipse 38",
    cx: 3.939,
    cy: 3.939,
    r: 3.939,
    transform: "translate(-6787.827 -21545.047)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_574",
    "data-name": "Trazado 574",
    d: "M716.691,395.318a2.671,2.671,0,1,1,0,5.343h-41.43a2.671,2.671,0,0,1,0-5.343h41.43m0-.654h-41.43a3.326,3.326,0,0,0,0,6.652h41.43a3.326,3.326,0,1,0,0-6.652Z",
    transform: "translate(-7437.287 -21939.498)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_575",
    "data-name": "Trazado 575",
    d: "M709.822,401.315H666.857a3.326,3.326,0,0,1,0-6.652h42.965a3.326,3.326,0,0,1,0,6.652Z",
    transform: "translate(-7434.988 -21939.498)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_39",
    "data-name": "Elipse 39",
    cx: 3.939,
    cy: 3.939,
    r: 3.939,
    transform: "translate(-6787.827 -21528.691)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_576",
    "data-name": "Trazado 576",
    d: "M716.691,417.833a2.671,2.671,0,1,1,0,5.343h-41.43a2.671,2.671,0,0,1,0-5.343h41.43m0-.654h-41.43a3.326,3.326,0,0,0,0,6.652h41.43a3.326,3.326,0,1,0,0-6.652Z",
    transform: "translate(-7437.287 -21945.648)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_577",
    "data-name": "Trazado 577",
    d: "M684.305,423.83H666.857a3.326,3.326,0,0,1,0-6.651h17.448a3.326,3.326,0,0,1,0,6.652Z",
    transform: "translate(-7434.988 -21945.648)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_255",
    "data-name": "Rect\\xE1ngulo 255",
    width: 294.305,
    height: 150.831,
    transform: "translate(-7122.811 -21660.254)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_256",
    "data-name": "Rect\\xE1ngulo 256",
    width: 274.685,
    height: 135.842,
    transform: "translate(-7113 -21652.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_578",
    "data-name": "Trazado 578",
    d: "M449,367.957H248.76a.627.627,0,0,1-.627-.627V271.355a.627.627,0,0,1,1.253,0V366.7H449a.627.627,0,0,1,0,1.253Z",
    transform: "translate(-7321.383 -21905.598)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_579",
    "data-name": "Trazado 579",
    d: "M300.328,384.218H282.115a1.862,1.862,0,0,1-1.86-1.86V357.252a1.862,1.862,0,0,1,1.86-1.86h18.213a1.862,1.862,0,0,1,1.86,1.86v25.106A1.862,1.862,0,0,1,300.328,384.218Z",
    transform: "translate(-7330.167 -21928.756)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_580",
    "data-name": "Trazado 580",
    d: "M346.043,375.253H327.831a1.862,1.862,0,0,1-1.86-1.86v-48.92a1.862,1.862,0,0,1,1.86-1.86h18.213a1.862,1.862,0,0,1,1.86,1.86v48.919a1.862,1.862,0,0,1-1.861,1.86Z",
    transform: "translate(-7342.671 -21919.791)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_581",
    "data-name": "Trazado 581",
    d: "M391.759,384.218H373.546a1.862,1.862,0,0,1-1.86-1.86V357.252a1.862,1.862,0,0,1,1.86-1.86h18.213a1.862,1.862,0,0,1,1.86,1.86v25.106A1.862,1.862,0,0,1,391.759,384.218Z",
    transform: "translate(-7355.173 -21928.756)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_582",
    "data-name": "Trazado 582",
    d: "M437.475,371.715H419.262a1.822,1.822,0,0,1-1.86-1.776V311.451a1.822,1.822,0,0,1,1.86-1.776h18.213a1.821,1.821,0,0,1,1.86,1.776v58.488A1.821,1.821,0,0,1,437.475,371.715Z",
    transform: "translate(-7367.674 -21916.246)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_583",
    "data-name": "Trazado 583",
    d: "M483.19,365.346H464.978a1.862,1.862,0,0,1-1.86-1.86V288.247a1.862,1.862,0,0,1,1.86-1.86H483.19a1.862,1.862,0,0,1,1.86,1.86v75.239A1.862,1.862,0,0,1,483.19,365.346Z",
    transform: "translate(-7380.179 -21909.883)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40",
    "data-name": "Elipse 40",
    cx: 3.76,
    cy: 3.76,
    r: 3.76,
    transform: "translate(-7042.706 -21588.402)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_41",
    "data-name": "Elipse 41",
    cx: 3.76,
    cy: 3.76,
    r: 3.76,
    transform: "translate(-7009.493 -21612.844)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_42",
    "data-name": "Elipse 42",
    cx: 3.76,
    cy: 3.76,
    r: 3.76,
    transform: "translate(-6976.281 -21588.402)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_43",
    "data-name": "Elipse 43",
    cx: 3.76,
    cy: 3.76,
    r: 3.76,
    transform: "translate(-6943.067 -21624.746)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_44",
    "data-name": "Elipse 44",
    cx: 3.76,
    cy: 3.76,
    r: 3.76,
    transform: "translate(-6909.854 -21638.537)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_584",
    "data-name": "Trazado 584",
    d: "M232.987,187.489l-33.292-24.936-32.838,24.6-.751-1,33.589-25.159L232.828,185.8l32.926-36.031.132-.054L299.1,136.337l.469,1.162-33.081,13.329Z",
    transform: "translate(-7205.428 -21771.287)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_516",
    "data-name": "Grupo 516",
    transform: "translate(-6814.539 -21692.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_547",
    "data-name": "Trazado 547",
    d: "M879.6,425.5l3.471-27.822a37.571,37.571,0,0,1,74.564,9.3L954.161,434.8a5.052,5.052,0,0,1-5.633,4.383l-64.548-8.053A5.052,5.052,0,0,1,879.6,425.5Z",
    transform: "translate(-642.246 -364.755)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_36",
    "data-name": "Elipse 36",
    cx: 27.546,
    cy: 27.546,
    r: 27.546,
    transform: "translate(240.725 13.955)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_548",
    "data-name": "Trazado 548",
    d: "M875.068,397.251a29.754,29.754,0,0,1,33.171-25.813l5.565.694A29.753,29.753,0,0,1,939.616,405.3l-.069.556-11.76-1.467-2.609-11.731-2.2,11.131-6.078-.758-1.317-5.919-1.112,5.616L875,397.808Z",
    transform: "translate(-643.343 -363.203)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_549",
    "data-name": "Trazado 549",
    d: "M796.193,481.022a12.689,12.689,0,0,0,18.961,4.36l25.019,14.657,12.615-13.032-35.623-20.2a12.757,12.757,0,0,0-20.973,14.216Z",
    transform: "translate(-662.648 -341.262)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_550",
    "data-name": "Trazado 550",
    d: "M872.349,511.447c-18.455,0-50.929-8.261-52.727-8.723l-.568-.145,5.111-25.877,49.6,9.8,26.946-37.946,30.937-3.145-.863,1.136c-.4.529-40.282,53.027-46.488,61.834C882.732,510.6,878.258,511.447,872.349,511.447Z",
    transform: "translate(-656.803 -345.35)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_551",
    "data-name": "Trazado 551",
    d: "M871.01,610.188l-.739-.352c-.157-.075-15.836-7.7-23.958-22.59-8.082-14.818,29.754-77.677,32.4-82.038l.038-19.962,13.61-36.747,17.358-9.811-14.9,34.773Z",
    transform: "translate(-650.517 -346.968)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_552",
    "data-name": "Trazado 552",
    d: "M728.005,628H711.416l-7.893-63.989h24.484Z",
    transform: "translate(-524.902 -150.225)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_553",
    "data-name": "Trazado 553",
    d: "M865.767,767l-53.492,0v-.677a20.821,20.821,0,0,1,20.819-20.82h32.674Z",
    transform: "translate(-658.434 -273.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_554",
    "data-name": "Trazado 554",
    d: "M875.267,615.665,859.5,620.83,832.077,562.48l23.267-7.623Z",
    transform: "translate(-493.972 -152.427)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_555",
    "data-name": "Trazado 555",
    d: "M1012.99,753.37l-50.828,16.655-.211-.643a20.821,20.821,0,0,1,13.3-26.268h0l31.047-10.172Z",
    transform: "translate(-622.672 -276.169)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_556",
    "data-name": "Trazado 556",
    d: "M1006.082,787.264,958.79,708.311l-39.922-84.352-35.925,74.511-14.272,96.5-50.049.7.2-.783,76.591-304.333,59.986,8.961-2.73,39.6,1.626,2.313c13.551,19.25,27.561,39.153,19.525,60.608l22.78,67.641L1047.022,782.3Z",
    transform: "translate(-656.908 -334.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_557",
    "data-name": "Trazado 557",
    d: "M885.611,571.3c-8.692,0-18.609-9.925-13.464-26.869l-.333-.241,12.357-54.6c-10.784-15.423,3.434-28.151,4.766-29.288l6.787-12.216L925.67,429.1l15.152,125.888-.224.214C929.655,565.669,892.9,571.3,885.611,571.3Z",
    transform: "translate(-644.369 -349.275)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_558",
    "data-name": "Trazado 558",
    d: "M937.638,600.878a14.723,14.723,0,0,1-3.537-.374c-1.165-.292-3.05-1.775-5.963-11.261-11.583-37.711-25.258-151.18-15.323-162.284l.228-.255,16.313,2.719c1.356-1,8.472-5.968,15.037-5.1a9.965,9.965,0,0,1,6.819,4.031l.113.147,5.2,73.933,19.038,87-.456.207C974,590.146,950.223,600.878,937.638,600.878Z",
    transform: "translate(-635.069 -350.448)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_559",
    "data-name": "Trazado 559",
    d: "M925.89,552.773a12.689,12.689,0,0,0,11.987-15.325L961.757,521l-6.456-16.95-33.4,23.7a12.757,12.757,0,0,0,3.985,25.022Z",
    transform: "translate(-634.29 -331.241)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_560",
    "data-name": "Trazado 560",
    d: "M950,552.815l-21.271-15.6,29.9-40.771-22.945-40.491L945.95,426.6l.663,1.264c.309.589,30.951,58.962,36.3,68.317,5.561,9.731-30.978,54.289-32.536,56.181Z",
    transform: "translate(-630.415 -349.875)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_585",
    "data-name": "Trazado 585",
    d: "M1162.179,766.2H689.511a1.241,1.241,0,0,1,0-2.481h472.669a1.241,1.241,0,1,1,0,2.481Z",
    transform: "translate(-688.27 -268.764)",
    fill: "#ccc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebmaster);
export default __webpack_public_path__ + "static/media/webmaster.35ec47544f5959f054646c2fe562a524.svg";
export { ForwardRef as ReactComponent };